import { useState, useEffect } from "react";
import { message } from "antd";
import UserInviteService from "Services/AdminServices/UserInviteService";

function useUserInvite() {
  const [loading, setLoading] = useState(false);
  const [invites, setInvites] = useState([]);


  // Send Invite
  const sendUserInvitation = async (email) => {
    setLoading(true);
    try {
      await UserInviteService.sendUserInvitation(email);
      message.success("Invite sent successfully");
      fetchInvites(); // refresh list
    } catch (error) {
      console.error("error",error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Invites
  const fetchInvites = async () => {
    setLoading(true);
    try {
      const data = await UserInviteService.getUserInvitations();
      setInvites(data || []);
    } catch (error) {
      message.error("Error fetching invites");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvites();
  }, []);

  return {
    loading,
    invites,
    sendUserInvitation,
  };
}

export default useUserInvite;